"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var FilterLevelCalculator = (function () {
    function FilterLevelCalculator() {
    }
    FilterLevelCalculator.calculateLevel = function (mediumCases, totalRawCases) {
        var totalThreshold = configuration_1.PlanConfiguration.rawSampleTotalThreshold;
        var sampleThreshold = configuration_1.PlanConfiguration.rawSampleMediumThreshold;
        if (!mediumCases || !totalThreshold) {
            return FilterLevelCalculator._maxLevel;
        }
        if (mediumCases < sampleThreshold) {
            if (totalRawCases < totalThreshold) {
                return 0;
            }
            else {
                return 1;
            }
        }
        return FilterLevelCalculator._maxLevel;
    };
    FilterLevelCalculator._maxLevel = 99999;
    return FilterLevelCalculator;
}());
exports.FilterLevelCalculator = FilterLevelCalculator;
//# sourceMappingURL=FilterLevelCalculator.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/FilterLevelCalculator.js
// module id = 32
// module chunks = 0